import { RichTextBlock } from './RichTextBlock.jsx';
import { StatsBlock } from './StatsBlock.jsx';
import { FeatureGridBlock } from './FeatureGridBlock.jsx';
import { ComparisonBlock } from './ComparisonBlock.jsx';
import { StepListBlock } from './StepListBlock.jsx';
import { SpecsBlock } from './SpecsBlock.jsx';
import { FAQSection } from '../../ui/Accordion.jsx';

const ALT_BG = ['bg-white dark:bg-gray-900', 'bg-gray-50 dark:bg-gray-800'];

/**
 * Rendert das sections[]-Array. section.type bestimmt die Komponente;
 * der Hintergrund wechselt pro Block (visueller Rhythmus).
 */
export function BlockRenderer({ sections = [] }) {
  return sections.map((section, index) => {
    const background = ALT_BG[index % 2];
    switch (section.type) {
      case 'richtext':
        return <RichTextBlock key={index} background={background} {...section} />;
      case 'stats':
        return <StatsBlock key={index} background={background} {...section} />;
      case 'features':
        return <FeatureGridBlock key={index} background={background} {...section} />;
      case 'comparison':
        return <ComparisonBlock key={index} background={background} {...section} />;
      case 'steps':
        return <StepListBlock key={index} background={background} {...section} />;
      case 'specs':
        return <SpecsBlock key={index} background={background} {...section} />;
      case 'faq':
        return (
          <FAQSection
            key={index}
            headline={section.headline}
            subheadline={section.subheadline}
            items={section.items}
            className={background}
          />
        );
      default:
        return null;
    }
  });
}
